<template>
  <div
    class="submit-tender clearfix"
    style="display: inline-block"
  >
    <modal
      modalId="alert-modal"
      ref="alertModal"
    >
      <div slot="content">
        <p class="modal-pure-text">{{ $t('project.docs.approveAlert') }}</p>
      </div>
      <div slot="btns">
        <button
          type="button"
          class="btn btn--darkblue"
          @click="closeAlertModal()"
        >{{ $t('action.cancel') }}</button>
        <button
          type="button"
          class="btn btn--orange"
          @click="approve()"
        >{{ $t('action.accept') }}</button>
      </div>
    </modal>
  </div>
</template>

<script>
import EventBus from '@/utils/eventBus'
import notification from '@/utils/notification'
import { FOLDER_STATUS, ActionTypes } from '@/utils/consts'
import { updateFolderStatus } from '@/api/folders/request'
import { mapGetters, mapActions } from 'vuex'
import Modal from '@/controls/Modal'
import { PROJECT_FOLDER_STATUS } from '@/modules/projects/consts'

export default {
  name: 'ApproveFolder',
  beforeDestroyed () {
    if (this.alertModal) {
      this.alertModal.destroy()
    }
  },
  components: {
    Modal,
  },
  methods: {
    ...mapActions('projects', ['loadProject']),
    async init (folderId) {
      if (!this.alertModal) {
        this.alertModal = this.$refs.alertModal
      }
      this.openAlertModal()
      this.folderId = folderId
    },
    openAlertModal () {
      this.alertModal.open()
    },
    closeAlertModal () {
      this.alertModal.close()
    },
    async approve () {
      if (this.currentUser && this.folderId) {
        const reqJSON = {
          status: FOLDER_STATUS.APPR,
          actionHistory: {
            actionType: PROJECT_FOLDER_STATUS.APPROVE,
            approver: {
              id: this.currentUser.id,
              name: this.currentUser.displayName || this.currentUser.name,
              username: this.currentUser.username,
            },
          },
        }

        await updateFolderStatus(this.folderId, reqJSON, ActionTypes.folders.accept)
        await this.loadProject(this.currentProject.id)
        EventBus.$emit('modules.projects.documents.folderUpdated')
        this.closeAlertModal()
      } else {
        notification.fireNotification(false, this.$i18n.t('error.checkInput'))
      }
    },
  },
  computed: {
    ...mapGetters('projects', [
      'currentProject',
    ]),
    ...mapGetters('user', ['currentUser']),
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/popup';
</style>
